import { render } from "./CloseButton.vue?vue&type=template&id=59b0836b"
import script from "./CloseButton.vue?vue&type=script&lang=js"
export * from "./CloseButton.vue?vue&type=script&lang=js"
script.render = render

export default script